// extracted by mini-css-extract-plugin
export default {"Admin":"Admin_Admin__5FdPz","AdminMenu":"Admin_AdminMenu__BpVlL","Link":"Admin_Link__ZD5Un"};